import { DrawMode, FrenzyDirection, FrenzyFilledPolygon, FrenzyLine, FrenzyPolygon, LeptonState } from "../Model"

export enum GameState {
	IDLE,
  DRAWING,
	PLAYER_DYING,
	PLAYER_DIED,
	FILL_REQUIRED,
	FILLING,
	FILL_COMPLETED,
	LEPTON_DYING,
	LEPTON_DIED,
	DRAINING,
	DRAIN_COMPLETED,
	
}